import r from '../utils/request'

export const getAllCategoriesGroup = (idGroup) => {
  return r.get(`/groups/${idGroup}/categories`)
}
